// src/components/Popup.js
import React, {useEffect, useRef} from 'react';
import closeIcon from '../assets/img/icon_close.svg';

const Popup = ({open, onClose, data}) => {
    const popupWrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // 如果 popup 是開啟狀態，且點擊的區域不在 popup 內且不在 .item（例如講師卡）上，就關閉 popup
            if (
                open &&
                popupWrapperRef.current &&
                !popupWrapperRef.current.contains(event.target) &&
                !event.target.closest('.item')
            ) {
                onClose();
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [open, onClose, data]);

    if (!open || !data) return null;

    return (
        <div id="popup" className="popup show" style={{display: 'flex'}}>
            <div className="container">
                <div ref={popupWrapperRef} className="popup_wrapper">
                    <a href="#!" onClick={onClose} className="popup_close">
                        <img src={closeIcon} alt="Close Popup"/>
                    </a>
                    <div className="content card">
                        <figure>
                            <div className="card_pic">
                                <img src={data.logoLargeImageIdUrl} alt={data.name}/>
                            </div>
                        </figure>
                        <figcaption>
                            <span className="card_name">{data.name}</span>
                            <span className="card_company">{data.company}</span>
                            <span className="card_job">{data.jobTitle}</span>
                            <p>{data.introduction}</p>
                        </figcaption>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Popup;
